import styled from 'styled-components'
import { typography, color, space } from 'styled-system'
import shouldForwardProp from '@styled-system/should-forward-prop'
import { Heading } from '../MDS-web-ui/src'

/** Sentence-case page title heading (no uppercase branding). */
export const PageHeading = styled(Heading).withConfig({
  shouldForwardProp,
})(
  {
    fontFamily: 'inherit',
    textTransform: 'none',
    letterSpacing: 'normal',
  },
  typography,
  color,
  space,
)

PageHeading.displayName = 'PageHeading'
